import React from "react";
import { Card, Button, Icon, Label } from "semantic-ui-react";
import { ReactionButton } from "../../../Student/Forum/ReactionButton";
import moment from "moment";
import "./PostItemDetail.scss"

export function PostItemDetail(props) {
  const { post, getStatusLabel, onAction } = props;

  return (
    <Card className="post-card" fluid>
      <Card.Content>
        <Card.Header className="post-card__header">
          <div className="post-card__header-title">{post?.title}</div>
          <div className="post-card__header-labels">
            <Label
              className="post-card__resolve-label"
              size="large"
              color={post?.solved ? "blue" : "grey"}
              horizontal
              content={post?.solved ? "Resuelta" : "Sin resolver"}
            />
            {getStatusLabel(post?.status)}
          </div>
        </Card.Header>
        <Card.Meta>
          Por{" "}
          {`${post?.User?.firstname} ${post?.User?.lastname} ${post?.User?.secondLastname}`}{" "}
          • {post?.Subject.name} •{" "}
          {post?.createdAt &&
            moment.utc(post?.createdAt).local().format("DD/MM/YYYY hh:mm a")}
        </Card.Meta>
        <Card.Description>
          <div
            className="post-card__content"
            dangerouslySetInnerHTML={{ __html: post?.content }}
          />
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <ReactionButton targetType="post" target={post} />
      </Card.Content>
      {post?.status === 0 && (
        <Card.Content extra>
          <div className="ui two buttons">
            <Button
              basic
              color="green"
              onClick={() =>
                onAction(
                  "approve",
                  "¿Estás seguro que deseas aprobar la publicación?"
                )
              }
            >
              <Icon name="check" /> Aprobar
            </Button>
            <Button
              basic
              color="red"
              onClick={() =>
                onAction(
                  "reject",
                  "¿Estás seguro que deseas rechazar la publicación?"
                )
              }
            >
              <Icon name="x" /> Rechazar
            </Button>
          </div>
        </Card.Content>
      )}
      {!post?.solved && post?.status !== 2 && (
        <Button
          color="blue"
          onClick={() =>
            onAction(
              "resolve",
              "¿Estás seguro que deseas marcar como resuelta la publicación?"
            )
          }
        >
          <Icon name="check circle" /> Marcar como resuelto
        </Button>
      )}
    </Card>
  );
}
